import { useNuxtApp } from "#imports";
export const useDevice = () => useNuxtApp().$device;
